import { apiClient } from "./config";
import { useUserAuthStore } from "./stores/user_auth_store";

const AUTH_WHITELIST = ['/users/login/', '/users/logout/', '/api/token/refresh/', '/dashboard/send/mail/']
let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
        // if there is a error in a process queue
        if (error) {
            prom.reject(error)
        }
        else {
            prom.resolve(token)
        }
    })

    // clear the promise queue
    failedQueue = []
};

// Attaching request interceptor for attaching the token
// for validation
apiClient.interceptors.request.use((config) => {
    const authStore = useUserAuthStore();
    // set the value from the local storage
    authStore.getUserToken();
    const authToken = authStore.tokenInfo?.access ?? null

    if (authToken && !AUTH_WHITELIST.includes(config.url)) {
        config.headers.Authorization = `Bearer ${authToken}`
    }

    return config;
});

apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // if the response status is unauthorized 401
        // and if the response is not retried
        // and the API is not the part of the API whitelist
        if (error.response?.status === 401 &&
            !originalRequest._retry &&
            !AUTH_WHITELIST.includes(originalRequest.url)
        ) {

            // set the retry to true as it is already requested for the 2 time 
            originalRequest._retry = true;
            const authStore = useUserAuthStore()
            // set the value from the local storage
            authStore.getUserToken();

            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({
                        resolve: (token) => {
                            originalRequest.headers.Authorization = `Bearer ${token}`
                            resolve(apiClient(originalRequest))
                        },
                        reject,
                    })
                })
            }

            isRefreshing = true;

            //refresh the token and create a new request
            //send it again
            return await refreshOldToken(originalRequest, authStore)

        }

        return Promise.reject(error)
    }
)

async function refreshOldToken(originalRequest, authStore) {
    try {
        //refresh token
        await authStore.refreshToken()
        const authToken = authStore.tokenInfo?.access
        // set the headers for authorization token
        apiClient.defaults.headers.Authorization = `Bearer ${authToken}`

        // execute all the process which are not executed when the token was updating 
        processQueue(null, authToken)

        originalRequest.headers.Authorization = `Bearer ${authToken}`
        return await apiClient(originalRequest)
    } catch (error) {
        console.log("Logout happened: ", error)
        processQueue(error, null);

        // logout from the application
        await authStore.logout();
        return Promise.reject(error);
    } finally {
        isRefreshing = false;
    }
}